<template>
    <div class="preview-video-message">
        <PreviewAvatar />
        <div class="video-container">
          <img :src="thumbnailUrl" alt="thumbnail video" />
          <div class="video-placeholder">
            <i class="bx bx-play"></i>
          </div>
        </div>
    </div>
</template>

<script>
import PreviewAvatar from '../PreviewAvatar.vue';

export default {
  name: 'VideoMessagePreview',
  components: {
    PreviewAvatar
  },
  props: {
    thumbnailUrl: {
      type: String,
      required: true,
      default: '',
    }
  },
};
</script>

<style lang="scss" scoped>
.preview-video-message{
    padding-right: 60px;
    .video-container{
        position: relative;
        top: -14px;
        padding-left: 40px;
        width: 200px;
        height: auto;
        img{
            width: 100%;
            height: auto;
            border-radius: 8px;
        }
        .video-placeholder{
            position: absolute;
            top: 0;
            left: 40px;
            width: 80%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #00000066;
            border-radius: 8px;
            i{
                font-size: 40px;
                color: #fff;
            }
        }
    }
}
</style>
